import { FORM_SECTION_CONSTANTS } from "../../../web/businesslogic/formssection/constants";
import { FORM_STEP } from "../../../web/businesslogic/formssection/createform/constants";
import { CONSENT_STATUS } from "../../../web/businesslogic/formssection/manageforms/constants";
import { FIELD_TYPES } from "../../formdatavalidator/constants";
import { GRID_VIEW_COLORS } from "./constants";

export default class Forms {

	static getPayerKeys() {
		return {
			"PayerID": "PayerDetailId",
			"PayerLastName": "LastName",
			"PayerEmail": "Email",
			"PayerForeignAddress": "Foreign",
			"LastFiling": "LastFilling",
			"PayerAddress": "Address1",
			"PayerAddress2": "Address2",
			"PayerCity": "City",
			"PayerCountry": "Country",
			"PayerZIP": "ZipCode",
			"PayerPhNo": "PhoneNumber",
			"PayerState": "State",
			"PayerFedaralID": "IdNumber",
			"DisregardedEntity": "DisregardedEntity",
			"FedaralIDType": "IdType",
			"PayerFirstName": "FirstName",
			"PayerMiddleName": "MiddleName",
			"PayerSuffix": "Suffix",
			"PayerClientId": "ClientPayerId",
			"UnMaskRecipientTIN": "UnMaskRecipientTin",
		};
	}

	static getRecipientKeys() {
		return {
			"PayeeEmail": "emailid",
			"PayeeForeignAddress": "foreign",
			"PayeeTINStatus": "TinStatus",
			"PayeeFedaralID": "IdNumber",
			"PayeeIdType": "IdType",
			"PayeeID": "RecipentDetailId",
			"PayeeLastName": "LastName",
			"PayeeAddress": "Address1",
			"PayeeAddress2": "Address2",
			"PayeeCity": "City",
			"PayeeState": "State",
			"PayeeZIP": "ZipCode",
			"PayeePhNo": "Phone",
			"PayeeCountry": "Country",
		}
	}

	static getRecipientKeyFromPayeeKey(recipientKey) {
		const recipientKeyMapping = Forms.getRecipientKeys();
		if (recipientKey in recipientKeyMapping) {
			return recipientKeyMapping[recipientKey];
		} else {
			return false;
		}
	};

	static getPayerDetailsKey(payerKey) {
		const payerKeyMapping = Forms.getPayerKeys();
		if (payerKey in payerKeyMapping) {
			return payerKeyMapping[payerKey];
		} else {
			return false;
		}
	}

	static formStepFieldSorting(fieldsList) {
		fieldsList.sort((a, b) => {
			if (a?.StepViewSort?.Column !== b?.StepViewSort?.Column) {
				return (a?.StepViewSort?.Column || 0) - (b?.StepViewSort?.Column || 0); // ascending order
			}
			if (a?.StepViewSort?.SortValue !== b?.StepViewSort?.SortValue) {
				return (a?.StepViewSort?.SortValue || 0) - (b?.StepViewSort?.SortValue || 0); // ascending order
			}
			return (a?.Category || '').localeCompare(b?.Category || '');
		});
		return fieldsList;
	}

	static extractIRSLayoutPropertiesForBE(fields) {
		const transformedFields = {};
		for (let i = 0; i < fields.length; i++) {
			const field = fields[i];
			const fieldName = field['Name'];
			const irsLayout = field['IRSLayout'];

			transformedFields[fieldName] = {
				'colStart': irsLayout['colStart'] ?? 0,
				'colUnits': irsLayout['colUnits'] ?? 0,
				'rowStart': irsLayout['rowStart'] ?? 0,
				'rowUnits': irsLayout['rowUnits'] ?? 0,
				'groupId': irsLayout['groupId'] ?? 0,
				'shouldRenderBorder': irsLayout['shouldRenderBorder'] ?? false,
				'cssClassname': irsLayout['cssClassname'] ?? "",
				'displayLabel': irsLayout['displayLabel'] ?? true,
			};
		}
		return transformedFields;
	}

	static replaceKeysInIRSLabelsWVariables(originallabel, formData) {
		const formattedDateForDueDate = new Intl.DateTimeFormat('en-US', { month: 'long', day: 'numeric', year: 'numeric' }).format(new Date(new Date().getFullYear(), 0, 31));

		const replacementMap = {
			'SELECTEDYEAR': formData?.selectedYear ?? 'SELECTEDYEAR',
			'DUEDATE': formattedDateForDueDate,
		};

		let replacedString = originallabel;
		for (const searchText in replacementMap) {
			const replacementText = replacementMap[searchText];
			replacedString = replacedString.replace(new RegExp(searchText, 'g'), replacementText);
		}
		return replacedString;
	}

	static getPayerAndRecipientColorErrorStatus(isRecipientErrorFree, payerTin, errorPayerIds) {
		let recipientColor, payerColor, isPayerErrorFree;
		if (errorPayerIds.hasOwnProperty(payerTin)) {
			isPayerErrorFree = false;
		} else {
			isPayerErrorFree = true;
		}

		switch (isRecipientErrorFree) {
			case true: // If recipient has no error
				switch (isPayerErrorFree) {
					case true: // If payer has no error
						recipientColor = GRID_VIEW_COLORS.GREEN;
						payerColor = GRID_VIEW_COLORS.GREEN;
						break;
					case false: // If payer has error
						recipientColor = GRID_VIEW_COLORS.GREEN;
						payerColor = GRID_VIEW_COLORS.RED;
						break;
					default:
						recipientColor = GRID_VIEW_COLORS.GREEN;
						payerColor = GRID_VIEW_COLORS.GREEN;
						break;
				}
				break;
			case false: // If recipient has error
				switch (isPayerErrorFree) {
					case true: // If payer has no error
						recipientColor = GRID_VIEW_COLORS.RED;
						payerColor = GRID_VIEW_COLORS.YELLOW;
						break;
					case false:  // If payer has error
						recipientColor = GRID_VIEW_COLORS.RED;
						payerColor = GRID_VIEW_COLORS.RED;
						break;
					default:
						recipientColor = GRID_VIEW_COLORS.GREEN;
						payerColor = GRID_VIEW_COLORS.GREEN;
						break;
				}
				break;
			default:
				recipientColor = GRID_VIEW_COLORS.GREEN;
				payerColor = GRID_VIEW_COLORS.GREEN;
				break;
		}
		return { recipientColor, payerColor };
	}

	static getJsonPreferences(formsList = [], selectedFormsList = [], formType = "", highlightedForm = null) {

		const jsonPreference = formsList.map(item => {
			let obj = {
				value: item.FormId, 
				ScheduleDate: item?.ScheduleDropDown ?? "", 
				EmailKey: `${item.IsEmailRecipient}`, 
				UspsKey: item.IsUSPSMail, 
				TinKey: item.IsTinCheck, 
				StateKey: item.IsState, 
				State: item?.State || "", 
				Foreignkey: item?.Foreign || "0"
			};

			if (highlightedForm?.FormId) {
				obj.key = (item.FormId === highlightedForm?.FormId);
			} else {
				obj.key = selectedFormsList.some(selectedItem => selectedItem.FormId === item.FormId);
			}
			obj.key = `${obj.key}`;

			if (formType) {
				obj.formType = formType;
			}

			if (item.PayerId) {
				obj.PayerId = item.PayerId;
			}

			return obj;
		});

		return jsonPreference;

	}

	static getCategorisedFormFields(formFields, formData) {

		const result = { [`${FORM_STEP.FEDERAL}`]: {}, [`${FORM_STEP.STATE}`]: {}, [`${FORM_STEP.STATEPAYROLL}`]: {} };

		formFields.forEach(item => {
			let category = item?.Category;
			let name = item?.Name;

			if ([FORM_STEP.FEDERAL, FORM_STEP.STATE].includes(category) && name in formData) {
				result[category][name] = { ...item, Value: formData[name] };
			}
			else if([FORM_STEP.STATEPAYROLL].includes(category) && name in formData){
				result[category][name] = { ...item, Value: formData[name] };
			}			
		});

		return result;
	}

	static getConsentStatusFromID(id) {
        switch (id) {
            case 0:
                return CONSENT_STATUS[0];

            case 1:
                return CONSENT_STATUS[1];

            case 6:
                return CONSENT_STATUS[6];
            
            default:
                return "Not Requested";
        }
    }

	static checkErrorForEachRelevantField(currentStep = "", tempFormFieldsList, isIRSViewOn = false, formDataValidatorCb, isBoiReportingModule = false){
		let isErrorFree = true;
		const newTempFormFieldsList = tempFormFieldsList.map(item => {
            if((item?.Category && item.Category === currentStep) || (isIRSViewOn && item?.IRSLayout) || isBoiReportingModule){
                if(item.hasOwnProperty("isVisible") && item?.isVisible === false){
                    return item;
                }

				if(item?.validationResult?.errorSentFromBE){
					isErrorFree = false;
                    return item;
				}
                const inputValidationResult = formDataValidatorCb(item, tempFormFieldsList);
                if(inputValidationResult?.isError){
                    isErrorFree = false;
                    return {
                        ...item,
                        validationResult: inputValidationResult,
                    }
                }else{
                    return {
                        ...item,
                        validationResult: inputValidationResult,
                    }
                }
            }else{
                return item;
            }
        });

		return {
			newTempFormFieldsList,
			isErrorFree,
		};
	}

	static importGridPageSelectedPayerIds = (gridViewPayerList, multiplePayerLocation = false) => {
		const { selectedPayerIdsArray, selectedPayerDisregardedEntitiesArray } = gridViewPayerList
			.filter((item) => item?.checked)
			.reduce(
				(acc, item) => {
				acc.selectedPayerIdsArray.push(item?.Id);
				if(multiplePayerLocation){
					acc.selectedPayerDisregardedEntitiesArray.push(item?.DisregardedEntity ?? '');
				}
				return acc;
				},
				{ selectedPayerIdsArray: [], selectedPayerDisregardedEntitiesArray: [] }
		);
		return {selectedPayerIdsArray: selectedPayerIdsArray, selectedPayerDisregardedEntitiesArray: selectedPayerDisregardedEntitiesArray}
	}

	static isPayerSelectionAllowed = (allowPayerSelection, toCreateFormData) => {
        if(!toCreateFormData?.FormRecordId || (toCreateFormData?.FormRecordId && allowPayerSelection)){
            return true
        }else {
            return false
        }
    }
	
	static groupFormFields = (groupedFields, formField) => {
		let group = groupedFields.find((group) => group[0]?.GroupId === formField.GroupId);

		if (!group) {
			group = [];
			groupedFields.push(group);
		}

		group.push(formField);
	}

	static stringifyFormFields (type = FIELD_TYPES.FILE_UPLOAD, allFieldsArr){
		const updatedAllFieldsFromResponse =  allFieldsArr.map(item => {
			if(item?.Type === type){
				let itemObj = {...item};
				if(item?.inputValue){
					itemObj = {
						...itemObj,
						inputValue: JSON.stringify(item?.inputValue)
					}
				}
				return itemObj
			}else{
				return item
			}
		})

		return updatedAllFieldsFromResponse
	}

	static deStringifyFormFields (type = FIELD_TYPES.FILE_UPLOAD, allFieldsArr){
		const updatedAllFieldsFromResponse =  allFieldsArr.map(item => {
			if(item?.Type === type){
				let itemObj = {...item};
				if(item?.inputValue){
					itemObj = {
						...itemObj,
						inputValue: JSON.parse(item?.inputValue)
					}
				}
				return itemObj
			}else{
				return item
			}
		})

		return updatedAllFieldsFromResponse
	}


	static getSubmittedFormsCreatePayload = (payload) => ({
		"sort": null,
		"page": payload.pageNumber,
		"pageSize": payload.pageSize,
		"group": null,
		"filter": null,
		"jsonPreferences": payload.jsonPreferences,
		"payerId": payload.payerId,
		"formId": payload.formId,
		"taxyear": payload.taxyear,
		"formname": payload.formname,
		"formType": payload.formType,
		"statustype": payload.statustype,
		"filingType": payload.filingType,
		"payeeName": payload.payeeName,
		"payeeTIN": payload.payeeTIN,
	});
}